import { action } from 'satcheljs/lib/legacy';
import MailboxOptions from 'owa-service/lib/contract/MailboxOptions';
import setMailboxForwardingConfiguration from '../services/setMailboxForwardingConfiguration';
import store from '../store/store';

export default action('saveMailboxForwardingConfiguration')(
    async function saveMailboxForwardingConfiguration(
        mailboxForwardingConfiguration: MailboxOptions
    ) {
        store.mailboxForwardingConfiguration = mailboxForwardingConfiguration;
        await setMailboxForwardingConfiguration(mailboxForwardingConfiguration);
    }
);
